import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCLibraryChildrenAttendingLibraryClasses = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Children attending library classes >=80% (%)" />
    </Box>
  );
};
